import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const CoachRoute = ({ children }) => {
  const { user, profile, loading, getDefaultDashboard } = useAuth();

  if (loading) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        Loading...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Allow coaches, admins, and super admins to access
  if (
    !profile ||
    (profile.role !== 'coach' && profile.role !== 'admin' && profile.role !== 'super_admin')
  ) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          gap: '20px',
        }}
      >
        <h1>Access Denied</h1>
        <p>You need coach or admin privileges to access this page.</p>
        <a href={`/${getDefaultDashboard()}`} style={{ color: '#007bff' }}>
          Return to Dashboard
        </a>
      </div>
    );
  }

  return children;
};

export default CoachRoute;
